import BaseService from '../baseServices';
import REST from '../../configs/rest';

function postUpload({ body }) {
  return BaseService.post(REST.UPLOAD_CSV, body);
}

function downloadFile({ fileName }) {
  return `${process.env.REACT_APP_REST_URL}${REST.IMAGES}?file=${fileName}`;
}

export default {
  postUpload,
  downloadFile,
};
